import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals/attribution';
import { emit } from './client.js';

// metric.name ∈ {CLS, FCP, INP, LCP, TTFB} — all on the server allow-list.
// Keep prop values numeric or short: the server PII firewall drops any STRING
// prop with ≥8 digits and a separator (phone heuristic). `value` is numeric here,
// so it is never stringified/scanned — but a future string-valued prop (formatted
// id, "12:34:56" duration) could be silently dropped server-side.

const cap = (s) => (typeof s === 'string' ? s.slice(0, 100) : undefined);

// Extract a small, bounded attribution subset per metric type.
// Returns undefined when no useful fields are present (prevents empty-object noise).
function extractAttribution(metric) {
  const a = metric.attribution;
  if (!a) return undefined;
  try {
    if (metric.name === 'INP') {
      const interactionTarget = cap(a.interactionTarget);
      const interactionType = cap(a.interactionType);
      if (interactionTarget == null && interactionType == null) return undefined;
      const out = {};
      if (interactionTarget != null) out.interactionTarget = interactionTarget;
      if (interactionType != null) out.interactionType = interactionType;
      return out;
    }
    if (metric.name === 'LCP') {
      const element = cap(a.element);
      // Strip query string and fragment before capping so signed-CDN credentials
      // and high-cardinality params never reach the telemetry store (PII/cardinality).
      const rawUrl = typeof a.url === 'string' ? a.url.replace(/[?#].*$/, '') : a.url;
      const url = cap(rawUrl);
      if (element == null && url == null) return undefined;
      const out = {};
      if (element != null) out.element = element;
      if (url != null) out.url = url;
      return out;
    }
    if (metric.name === 'CLS') {
      const largestShiftTarget = cap(a.largestShiftTarget);
      if (largestShiftTarget == null) return undefined;
      return { largestShiftTarget };
    }
  } catch {
    // attribution extraction must never throw into the app
  }
  return undefined;
}

function report(metric) {
  const props = { value: metric.value, rating: metric.rating, id: metric.id };
  const attribution = extractAttribution(metric);
  if (attribution !== undefined) props.attribution = attribution;
  emit({ event_type: 'web_vital', name: metric.name, props });
}

export function registerVitals() {
  onCLS(report);
  onFCP(report);
  onINP(report);
  onLCP(report);
  onTTFB(report);
}
